module.exports = "/assets/dist/images/shop-logo.svg?aac285b07907defa00fe558c7d52c568";